const RightWrapper=({children})=>(
    <div className="m-3 rounded-md h-fit min-h-[100vh] w-full">
        {children}
    </div>
)

const RadianButtonGroup = ({ options, value, onChange }) => {
  return (
    <div className="flex gap-4">
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <div
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`flex items-center cursor-pointer text-xs font-medium ${
              isSelected ? "text-red-500" : "text-gray-800"
            }`}
          >
            {/* Circle indicator */}
            <span
              className={`w-3 h-3 mr-2 rounded-full border border-gray-500 flex items-center justify-center`}
            >
              {isSelected && (
                <span className="w-2 h-2 rounded-full bg-red-300"></span>
              )}
            </span>

            {/* Label */}
            <span
              className={`px-2.5 py-0.5 rounded border ${
                isSelected
                  ? "border-red-400 bg-red-100"
                  : "border-gray-500 bg-white"
              }`}
            >
              {option.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export {RadianButtonGroup}

export default RightWrapper